
<script setup>

  import { ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import backgroundPath from '../images/lunch-background.jpg';

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="p-6 md:p-12 lg:p-24">

        <div class="max-w-xl text-center">

          <h3 class="text-5xl font-heading uppercase">

            It's Lunchtime

          </h3>

          <p class="mt-8 leading-7 text-neutral-700">

            Your family is starting to get hungry.

            Choosing where to eat when traveling can be a tricky decision.

            Where do you stop?

          </p>

          <p class="mt-8 font-bold">Select a place to eat on the following screen.</p>

          <RouterLink
          
            class="inline-flex items-center gap-4 px-6 py-4 mt-12 text-white font-bold text-white bg-green-700 transition-colors
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
          
            to="/activity/2/part/5/b">

            <span>Continue</span>

            <ArrowRightCircleIcon class="w-8" />

          </RouterLink>

        </div>

      </div>

    </div>

  </article>

</template>
